// export let OemModalLayoutJSON = [
//   {
//     name: "New",
//     child: [
//       {
//         parentid: "section-1720177232612-form",
//         elementid: "1720177234978",
//         elementtype: "textfield",
//       },
//       {
//         parentid: "section-1720177232612-form",
//         elementid: "1720177239560",
//         elementtype: "textarea",
//       },
//       {
//         parentid: "section-1720177232612-form",
//         elementid: "1720177249476",
//         elementtype: "documentFile",
//       },
//       {
//         parentid: "section-1720177232612-form",
//         elementid: "1720177264442",
//         elementtype: "customSelect",
//       },
//     ],
//     parentid: "myTabContent",
//     elementid: "section-1720177232612",
//     description: "",
//     elementtype: "section",
//     "section-type": "form",
//     linkedentitytype: -1,
//   },
// ];

export let OemModalLayoutJSON = [
  {
    name: "New",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1718962081569-col-1",
                elementid: "1720177234978",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718962081569-columns",
            elementid: "1718962081569-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                colsize: "2",
                parentid: "1718962081569-col-2",
                elementid: "1720177249476",
                elementtype: "documentFile",
              },
            ],
            colpos: 2,
            parentid: "1718962081569-columns",
            elementid: "1718962081569-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "1718962070420-fieldset-body",
        elementid: "1718962081569",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718962084686-col-1",
                elementid: "1720177239560",
                elementtype: "textarea",
              },
            ],
            colpos: 1,
            parentid: "1718962084686-columns",
            elementid: "1718962084686-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718962084686-col-2",
                elementid: "1720177264442",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1718962084686-columns",
            elementid: "1718962084686-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "1718962070420-fieldset-body",
        elementid: "1718962084686",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1718962067510",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let UploadLayoutJSON = [
  {
    name: "New",
    child: [
      {
        parentid: "section-1720177232613-form",
        elementid: "1717412405877",
        elementtype: "documentFile",
      },
      {
        parentid: "section-1720177232613-form",
        elementid: "1717412405888",
        elementtype: "documentFile",
      },
    ],

    parentid: "myTabContent",
    elementid: "section-1720177232613",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];
